import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SaldoLayer from "../components/SaldoLayer";





const SaldoMitra = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Saldo Mitra" />

        {/* KanbanLayer */}
        <SaldoLayer />

      </MasterLayout>

    </>
  );
};

export default SaldoMitra; 
